import React from 'react';

interface DataTableCardProps {
  children: React.ReactNode;
}

/** Envuelve DataTable para que la tabla y la paginación formen un solo bloque visual integrado */
export default function DataTableCard({ children }: DataTableCardProps) {
  return (
    <div className="rounded-xl border border-rs-border overflow-hidden bg-rs-surface">
      {children}
    </div>
  );
}
